__webpack_require__.p = "https://store.tea.mag.dev/";